import { CommonUtilities } from '../../commonUtils';

export default class dataLoaderServices {


    public static dataLoaderSearch = [
        {
            field_display: ["Contact Code", "Contact Name", "email",],
            field_code: ["kontactCode", "kontactName", "email"],
            className: "ws-4", fieldType: "text", for: "BasicContactDetails", fieldFor: "Contacts"
        },

        {
            field_display: ["Contact Code", "Contact Name", "email",],
            field_code: ["kontactCode", "kontactName", "email"],
            className: "ws-4", fieldType: "text", for: "AdditionalContactRecipients", fieldFor: "Contacts"
        },

        {
            field_display: ["Contact Code", "Contact Name", "email",],
            field_code: ["kontactCode", "kontactName", "email"],
            className: "ws-4", fieldType: "text", for: "ContactStatuses", fieldFor: "Contacts"
        },

        {
            field_display: ["Artist/Code", "Contract Ref", "Title",],
            field_code: ["artist", "contractRefNum", "contractTitle"],
            className: "ws-4", fieldType: "text", fieldFor: "Contracts", for: "rateBasis"
        },
        {
            field_display: ["Artist/Code", "Contract Ref", "Title",],
            field_code: ["artist", "contractRefNum", "contractTitle"],
            className: "ws-4", fieldType: "text", fieldFor: "Contracts", for: "regions"
        },
        {
            field_display: ["Artist/Code", "Contract Ref", "Title",],
            field_code: ["artist", "contractRefNum", "contractTitle"],
            className: "ws-4", fieldType: "text", fieldFor: "Contracts", for: "adjustments"
        },
        {
            field_display: ["Artist/Code", "Contract Ref", "Title",],
            field_code: ["artist", "contractRefNum", "contractTitle"],
            className: "ws-4", fieldType: "text", fieldFor: "Contracts", for: "reserves"
        },
        {
            field_display: ["Artist/Code", "Contract Ref", "Title",],
            field_code: ["artist", "contractRefNum", "contractTitle"],
            className: "ws-4", fieldType: "text", fieldFor: "Contracts", for: "reducingRoyalties"
        },
        {
            field_display: ["Artist/Code", "Contract Ref", "Title",],
            field_code: ["artist", "contractRefNum", "contractTitle"],
            className: "ws-4", fieldType: "text", fieldFor: "Contracts", for: "contractStatus"
        },
        {
            field_display: ["Artist/Code", "Contract Ref", "Title",],
            field_code: ["artist", "contractRefNum", "contractTitle"],
            className: "ws-4", fieldType: "text", fieldFor: "Contracts", for: "contractGrouping"
        },

        {
            field_display: ["Artist/Code", "Track Name", "ISRC", "Title", "Contract Ref", "Release Code"],
            field_code: ["artist", "trackName", "isrc", "contractTitle", "contractRefNum", "releaseCode"],
            className: "ws-4", fieldType: "text", fieldFor: "Contract Links"
        },

        {
            field_display: ["Writer", "Contract Ref/Title", "Publisher", "Collector"],
            field_code: ["writer", "contract", "publisher", "collector"],
            className: "ws-3", fieldType: "text", for: "mechanicalContract",
            fieldFor: "Upload Mechanicals"
        },
        {
            field_display: ["Writer", "Contract Ref/Title", "Publisher", "Collector", "Track Artist", "Track Title", "Release Code",],
            field_code: ["writer", "contract", "publisher", "collector", "trackartist", "tracktitle", "releaseCode"],
            className: "ws-3", fieldType: "text", for: "mechanicalTrackSplits",
            fieldFor: "Upload Mechanicals"
        },
        {
            field_display: ["Writer", "Contract Ref/Title", "Publisher", "Collector", "Artist", "ISRC", "Release Code",],
            field_code: ["writer", "contract", "publisher", "collector", "artist", "isrc", "releaseCode"],
            className: "ws-3", fieldType: "text", for: "mechanicalLicenses",
            fieldFor: "Upload Mechanicals"
        },

        {
            field_display: ["Unique ID", "Invoice Ref", "Account Code"],
            field_code: ["artist", "trackName", "isrc", "contractTitle", "contractRefNum", "releaseCode"],
            className: "ws-3", fieldType: "text", for: "mappingRaw",
            fieldFor: "Mappings"
        },
        {
            field_display: ["Rep Album Code 1/2", "Rep Track Code 1/2", "Item Code", "Territory", "Format", "Analysis Code", "Artist", "Title", "Price", "Sub Provider", "Sub Content", "Sub Formats/Source Codes", "Description", "Royalty Period", "Monetary Value From", "Monetary Value To", "Transaction Ref"],
            field_code: ["repAlbumCode", "repTrackCode", "itemCodeSold", "territory", "format", "analysisCode", "artist", "title", "price", "subprovider", "subcontent", "subformat", "description", "royaltyPeriod", "monetaryFrom", "monetaryTo", "transRef"],
            className: "ws-3", fieldType: "text", hidden: true, for: "mappingRaw",
            fieldFor: "Mappings"
        },

        {
            field_display: ["Unique ID", "Invoice Ref", "Account Code"],
            field_code: ["artist", "trackName", "isrc", "contractTitle", "contractRefNum", "releaseCode"],
            className: "ws-3", fieldType: "text", for: "mappingRawPub",
            fieldFor: "Mappings"
        },
        {
            field_display: ["Song Code", "HFA Code", "ISWC", "Item Code", "Territory", "Song Title", "Writer Name", "Publisher Name", "Header Type", "Royalty Period", "Monetary Value From", "Monetary Value To"],
            field_code: ["songCode", "hFACode", "iSWC", "itemCodeSold", "territory", "title", "writerName", "publisherName", "headerType", "royaltyPeriod", "monetaryFrom", "monetaryTo"],
            className: "ws-3", fieldType: "text", hidden: true, for: "mappingRawPub",
            fieldFor: "Mappings"
        },
        {
            field_display: ["Code", "Artist", "Title", "Label"],
            field_code: ["assetCode", "assetContactName", "assetTitle", "labelName"],
            className: "ws-3", fieldType: "text", hidden: true, for: "Tracks",
            fieldFor: "Minimum Set Uploader"
        },
        {
            field_display: ["Code", "Artist", "Title", "Label"],
            field_code: ["assetCode", "assetContactName", "assetTitle", "labelName"],
            className: "ws-3", fieldType: "text", hidden: true, for: "Releases",
            fieldFor: "Minimum Set Uploader"
        },
        {
            field_display: ["CatLogNumber", "Currency Code", "Price Basis", "Territory Area"],
            field_code: ["catLogNumber", "currencyCode", "priceBasis", "territoryArea"],
            className: "ws-3", fieldType: "text", hidden: true, for: "Dealerprice",
            fieldFor: "Minimum Set Uploader"
        },
        {
            field_display: ["Release Code", "Release Title", "Track Title", "ISRC"],
            field_code: ["releaseCode", "releaseTitle", "trackTitle", "isrc"],
            className: "ws-3", fieldType: "text", hidden: true, for: "releaseTrack",
            fieldFor: "Minimum Set Uploader"
        },
        {
            field_display: ["Code", "Artist", "Title", "Label"],
            field_code: ["assetCode", "assetContactName", "assetTitle", "labelName"],
            className: "ws-3", fieldType: "text", hidden: true, for: "Songs",
            fieldFor: "Minimum Set Uploader"
        },
    ]

    public static SearchfieldName = [
        {
            fieldFor: "Contacts", for: "BasicContactDetails",
            fieldName: ["Contact Code", "Contact Name", "Contact Display", "Company Name", "First Name", "Last Name", "Email", "Website URL", "Address Line1", "Address Line2", "Address Line3", "Address Line4", "Address PostCode", "Telephone"],
            fieldCode: ["kontactCode", "kontactName", "kontactDisplay", "companyName", "firstName", "lastName", "email", "websiteURL", "addressLine1", "addressLine2", "addressLine3", "addressLine4", "addressPostCode", "telephone"]
        },
        {
            fieldFor: "Contacts", for: "AdditionalContactRecipients",
            fieldName: ["Contact Code", "Salutation", "First Name", "	Last Name", "Telephone", "Email"],
            fieldCode: ["kontactCode", "contactSalute", "firstName", "lastName", "telephone", "email"]
        },
        {
            fieldFor: "Contacts", for: "ContactStatuses",
            fieldName: ["Contact Code", "Statement Status Name", "Payee Status Name"],
            fieldCode: ["kontactCode", "statementStatusName", "payeeStatusName"]
        },
        {
            fieldFor: "Contracts",
            fieldName: ["Contract Ref", "Contract With", "Contact Code", "Title", "Type", "Reported"],
            fieldCode: ["contractRefNum", "contractTitle", "contactCode", "contractTitle", "type", "reported"]
        },
        {
            fieldFor: "Contract Links",
            fieldName: ["ReleaseCode", "TrackContactCode", "TrackName", "TrackArtist", "ISRC", "PercentageOwned", "ContractRefNum", "ContractWith", "ContactCode", "ContractTitle", "ContractType", "Reported"],
            fieldCode: ["catLogNumber", "trackContactCode", "trackName", "trackArtist", "intStdRecCode", "percentageOwned", "contractRefNum", "contractWith", "contactCode", "contractTitle", "type", "reported"]
        },
        {
            fieldFor: "Upload Mechanicals", for: "mechanicalContract",
            fieldName: ["Contract Ref", "Artist", "Title", "Formats/Source Codes", "Zone", "Rate"],
            fieldCode: ["contractRefNum", "contractArtist", "contractTitle", "mechFormat", "zoneCode", "mechRate"]
        },
        {
            fieldFor: "Upload Mechanicals", for: "mechanicalTrackSplits",
            fieldName: ["ISRC", "Artist", "Collector Name", "Formats/Source Codes", "Writer Name", "Publisher Name", "Release Code", "Title", "Controlled", "Zone"],
            fieldCode: ["iSRC", "trackArtist", "collectorName", "formatCode", "writerName", "mechRate"]
        },
        {
            fieldFor: "Upload Mechanicals", for: "mechanicalLicenses",
            fieldName: ["Artist", "Collector Name", "Publisher Name", "Writer Name", "Title", "ISRC", "Release Code", "Zone", "Formats/Source Codes"],
            fieldCode: ["trackArtist", "collectorName", "publisherName", "writerName", "trackTitle", "iSRC", "releaseCode", "zoneCode", "formatDesc"]
        },
        {
            fieldFor: "Mappings", for: "mappingRaw",
            fieldName: ["Unique ID", "Invoice Ref", "AlbumCode 1", "AlbumCode 2", "TrackCode 1", "TrackCode 2", "UPC", "Sub Content", "Sub Formats/Source Codes", "Sub Provider", "Royalty Period"],
            fieldCode: ["UniqueID", "InvoiceRef", "AlbumCode1", "AlbumCode2", "TrackCode1", "TrackCode2", "UPC", "SubContent", "SubFormat", "SubProvider", "RoyaltyPeriod"]
        },
        {
            fieldFor: "Mappings", for: "mappingRawPub",
            fieldName: ["Unique ID", "Invoice Ref", "SongCode 1", "SongCode 2", "SongCode 3", "SongCode 4", "HFA Code", "ISWC", "Reported Code", "Song Title", "Writer Name", "Publisher Name", "Header Type", "Royalty Period"],
            fieldCode: ["UniqueID", "invoiceref", "SongCode1", "SongCode2", "SongCode3", "SongCode4", "HFACode", "ISWC", "ItemCodeSold", "SongTitle", "WriterName", "PublisherName", "HeaderType", "RoyaltyPeriod"]
        },

        {
            fieldFor: "Minimum Set Uploader", for: "Tracks",
            fieldName: ["Code", "Title", "Artist", "Label"],
            fieldCode: ["assetCode", "assetTitle", "assetContactName", "assetImprint"]
        },
        {
            fieldFor: "Minimum Set Uploader", for: "Releases",
            fieldName: ["Code", "Title", "Artist", "Label"],
            fieldCode: ["assetCode", "assetTitle", "assetContactName", "assetImprint"]
        },

        {
            fieldFor: "Minimum Set Uploader", for: "Dealerprice",
            fieldName: ["CatLogNumber", "CurrencyCode", "CurrencyDealer", "DealerPrice", "ExchRate", "Lockprices", "PriceBasis", "TerritoryArea", "PriceID"],
            fieldCode: ["CatLogNumber", "currencyCode", "currencyDealer", "dealerPrice", "exchRate", "lockprices", "priceBasis", "territoryArea", "priceID"]
        },

        {
            fieldFor: "Minimum Set Uploader", for: "releaseTrack",
            fieldName: ["UPC", "Release Code", "Release Title", "Release Artist", "Label", "Release Format", "Tracks Title", "Tracks Artist", "ISRC", "Volume", "TrackNumber"],
            fieldCode: ["upc", "releaseCode", "releaseTitle", "releaseArtist", "label", "releaseFormat", "trackTitle", "trackArtist", "iSRC", "volume", "trackNumber"]
        },

        {
            fieldFor: "Minimum Set Uploader", for: "Songs",
            fieldName: ["Code", "Title", "Publisher", "Writer", "Label"],
            fieldCode: ["assetCode", "assetTitle", "publisher", "writer", "assetImprint"]
        },
    ]

    public static viewAllfieldName = [
        {
            fieldFor: "Contacts",
            fieldName: ["Contact Code", "Contact Name", "Contact Display", "Company Name", "First Name", "Last Name", "Email", "Website URL", "Address Line1", "Address Line2", "Address Line3", "Address Line4", "Address PostCode", "Telephone"],
            fieldCode: ["kontactCode", "kontactName", "kontactDisplay", "companyName", "firstName", "lastName", "email", "websiteURL", "addressLine1", "addressLine2", "addressLine3", "addressLine4", "addressPostCode", "telephone"]
        },
        {
            fieldFor: "Contracts",
            fieldName: ["Contract Ref", "Title", "Desc", "Contracted Party", "Label", "Type", "Reported"],
            fieldCode: ["contractRefNum", "contractTitle", "contractDesc", "contractedParty", "labelCode", "type", "reported"]
        },
        {
            fieldFor: "Contract Links",
            fieldName: ["Contract ref", "Contract Title", "Track Artist", "Code", "Track Name"],
            fieldCode: ["contractRefNum", "contractTitle", "trackArtist", "trackContactCode", "trackName"]
        },
        {
            fieldFor: "Upload Mechanicals", for: "mechanicalContract",
            fieldName: ["Contract Ref", "Artist", "Title", "Formats/Source Codes", "Zone", "Rate"],
            fieldCode: ["contractRefNum", "contractArtist", "contractTitle", "mechFormat", "zoneCode", "mechRate"]
        },
        {
            fieldFor: "Upload Mechanicals", for: "mechanicalTrackSplits",
            fieldName: ["ISRC", "Artist", "Collector Name", "Formats/Source Codes", "Writer Name", "Publisher Name", "Controlled", "Zone"],
            fieldCode: ["iSRC", "trackArtist", "collectorName", "formatCode", "writerName", "publisherName", "controlledYN", "zoneCode"]
        },
        {
            fieldFor: "Upload Mechanicals", for: "mechanicalLicenses",
            fieldName: ["Artist", "Collector Name", "Publisher Name", "Writer Name", "Title", "ISRC", "Release Code", "Zone", "Formats/Source Codes", "Controlled"],
            fieldCode: ["artistName", "collectorName", "publisherName", "writerName", "trackTitle", "iSRC", "releaseCode", "zoneCode", "formatCode", "controlledYN"]
        },
        {
            fieldFor: "Mappings", for: "mappingFormat",
            fieldName: ["Account Code", "Content", "Formats/Source Codes", "Provider", "Map To Code"],
            fieldCode: ["account", "subContent", "subFormat", "subProvider", "maptoCode"]
        },
        {
            fieldFor: "Mappings", for: "mappingCatalogue",
            fieldName: ["Account Code", "Artist", "Title", "Type", "Formats/Source Codes", "Album Code 1", "Album Code 2", "Track Code 1", "Track Code 2", "Item Code", "Rep Item Code"],
            fieldCode: ["accountCode", "albumArtist", "albumTitle", "headerType", "subFormat", "repAlbumCode1", "repAlbumCode2", "repTrackCode1", "repTrackCode2", "itemCodeSold", "repItemCodeSold"]
        },
        {
            fieldFor: "Mappings", for: "mappingRaw",
            fieldName: ["Account Code", "Invoice Ref", "Artist", "Title", "Item Code Sold", "Formats/Source Codes", "Provider", "Content", "Monetary Value"],
            fieldCode: ["accountCode", "invoiceRef", "albumArtist", "albumTitle", "itemCodeSold", "subFormat", "subProvider", "subContent", "monetaryValue"]
        },
        {
            fieldFor: "Mappings", for: "mappingAudit",
            fieldName: ["Account Code", "Invoice Ref", "Artist", "Title", "Item Code Sold", "Formats/Source Codes", "Provider", "Content", "Monetary Value"],
            fieldCode: ["accountCode", "invoiceRef", "albumArtist", "albumTitle", "itemCodeSold", "subFormat", "subProvider", "subContent", "monetaryValue"]
        },
        {
            fieldFor: "Mappings", for: "mappingAuditPub",
            fieldName: ["Account Code", "Invoice Ref", "Writer", "Item Code Sold", "Header Type", "Territory", "Royalty Period", "Monetary Value"],
            fieldCode: ["accountcode", "invoiceref", "writerName", "itemCodeSold", "headerType", "repTerritoryCode", "royaltyPeriod", "monetaryValue"]
        },
        {
            fieldFor: "Mappings", for: "mappingRawPub",
            fieldName: ["Account Code", "Invoice Ref", "Writer", "Publisher", "Title", "Rep Item Code Sold", "Header Type", "Royalty Period", "Code 1", "Code 2", "Code 3", "Code 4", "HFA", "ISWC", "Monetary Value"],
            fieldCode: ["accountcode", "invoiceref", "writerName", "publisherName", "albumTitle", "repItemCodeSold", "headerType", "royaltyPeriod", "songCode1", "songCode2", "songCode3", "songCode4", "hFACode", "iSWC", "monetaryValue"]
        },
        {
            fieldFor: "Mappings", for: "mappingAnalysisCode",
            fieldName: ["Code	Group", "Description	Costs", "Flat Fee", "Mechanicals", "Points", "Profits", "Analysis", "Analysis 2"],
            fieldCode: ["code", "group", "description", "costs", "flatFee", "mechanicals", "points", "profits", "analysisDIM1", "analysisDIM2"]
        },
        {
            fieldFor: "Mappings", for: "mappingClassList.excel",
            fieldName: ["Class List", "Release Alt 1", "Release Alt 2", "Release Alt 3", "Release Alt 4", "Release Alt 5", "Release Alt 6", "ISRC"],
            fieldCode: ["classList", "releaseAlt1", "releaseAlt2", "releaseAlt3", "releaseAlt4", "releaseAlt5", "releaseAlt6", "releaseIsRc"]
        },
        {
            fieldFor: "Mappings", for: "mappingClassList.mpm",
            fieldName: ["Class List", "Release Alt 1", "Release Alt 2", "Release Alt 3", "Release Alt 4", "Release Alt 5", "Release Alt 6", "ISRC"],
            fieldCode: ["classList", "releaseAlt1", "releaseAlt2", "releaseAlt3", "releaseAlt4", "releaseAlt5", "releaseAlt6", "releaseIsRc"]
        },
        {
            fieldFor: "Data Transfer", for: "artistContracts",
            fieldName: ["Artist", "Title", "Payor", "Payee", "Client Acc No"],
            fieldCode: ["f2", "f1", "f4", "f5", "f7"]
        },
        {
            fieldFor: "Data Transfer", for: "artistPayees",
            fieldName: ["Payee", "Client Acc No"],
            fieldCode: ["f1", "f2"]
        },
        {
            fieldFor: "Data Transfer", for: "transactionsLicense",
            fieldName: ["Artist", "Title", "Version", "Catalog No", "Label"],
            fieldCode: ["f4", "f1", "f2", "f3", "f5"]
        },
        {
            fieldFor: "Data Transfer", for: "transactionsPublisher",
            fieldName: ["Publisher", "Client Acc No"],
            fieldCode: ["f1", "f2"]
        },
        {
            fieldFor: "Minimum Set Uploader", for: "Releases",
            fieldName: ["Upc", "Title", "Artist", "Label", "Master Release", "Release Format", "Dim1", "ProductStatus", "ProductStatus Ext"],
            fieldCode: ["upc", "title", "artist", "label", "masterRelease", "releaseFormat", "dim1", "productStatus", "productStatusExt"]
        },
        {
            fieldFor: "Minimum Set Uploader", for: "Tracks",
            fieldName: ["Upc", "Title", "Artist", "Label", "Master Release", "Release Format", "Dim1", "ProductStatus", "ProductStatus Ext"],
            fieldCode: ["upc", "title", "artist", "label", "masterRelease", "releaseFormat", "dim1", "productStatus", "productStatusExt"]
        },
        {
            fieldFor: "Minimum Set Uploader", for: "Dealerprice",
            fieldName: ["Release Code", "CurrencyCode", "CurrencyDealer", "LocalDealer", "ExchRate", "PriceBasis", "TerritoryCode", "LicenseID", "Release Artist", "Release Title", "Dim1", "ProductStatus"],
            fieldCode: ["releaseCode", "currencyCode", "currencyDealer", "localDealer", "exchRate", "priceBasis", "territoryCode", "licenseID", "releaseArtist", "releaseTitle", "dim1", "productstatus"]
        },
        {
            fieldFor: "Minimum Set Uploader", for: "releaseTrack",
            fieldName: ["Upc", "Release Code", "Release Title", "Release Artist", "Master Release", "Label", "Master Release", "Release Format", "Tracks Title", "Tracks Artist", "ISRC", "volume", "Dim1", "ProductStatus", "ProductStatus Ext"],
            fieldCode: ["upc", "releaseCode", "releaseTitle", "releaseArtist", "masterRelease", "label", "masterRelease", "releaseFormat", "trackTitle", "trackArtist", "iSRC", "volume", "dim1", "productStatus", "productStatusExt"]
        },
        {
            fieldFor: "Minimum Set Uploader", for: "Songs",
            fieldName: ["Song Code", "Writer", "Publisher", "Share", "Song Title", "Imprint", "Dim1", "ProductStatus", "ProductStatus Ext"],
            fieldCode: ["songCode", "writer", "publisher", "share", "title", "imprint", "dim1", "productStatus", "productStatusExt"]
        },

        //CUE Upload
        {
            fieldFor: "CUE", for: "",
            fieldName: ["Cue Type", "Program Name", "Title", "ISWC", "Artist", "Cue Comment", "First Name", "Last Name", "Company", "Affiliation"],
            fieldCode: ["cueSheetType", "programName", "name", "iSWC", "artist", "cueComments", "firstName", "lastName", "companyName", "affiliation"]
        },
        {
            fieldFor: "Song", for: "",
            fieldName: ["Song Ref", "Title", "ISWC", "Composer 1", "Comp 1 %", "Composer 2", "Comp 2 %", "Publisher 1", "Pub 1 %", "Publisher 2", "Pub 2 %"],
            fieldCode: ["songRef", "songTitle", "iSWC", "composer1", "compPercent1", "composer2", "compPercent2", "publisher1", "pubPercent1", "publisher2", "pubPercent2"]
        },
        {
            fieldFor: "Release/Track", for: "Track",
            fieldName: ["Artist", "ISRC", "Label", "Version", "Title", "Track Seq", "Duration", "Date"],
            fieldCode: ["Display_Artist", "IntStdRecCode", "Label", "TitleVersion", "TrackName", "TrackSeq", "TrackDuration", "TrackFirstAvailableDate"]
        },
        {
            fieldFor: "Release/Track", for: "Releases",
            fieldName: ["Artist", "Barcode", "CatLogNumber", "Master Release", "Formats/Source Codes", "Title", "Label"],
            fieldCode: ["Artist", "BarcodeNum", "CatLogNumber", "MasterRelease", "Format", "Title", "Label"]
        },
        {
            fieldFor: "Release/Track", for: "releaseTrack",
            fieldName: ["Title", "ISRC", "Artist", "Track Name", "Barcode", "Formats/Source Codes", "Genre", "Sub-genre"],
            fieldCode: ["releaseTitle", "iSrC", "releaseArtist", "trackName", "barcode", "releaseFormat", "genre", "subGenre"]
        },
        {
            fieldFor: "Release/Track", for: "Distributor",
            fieldName: ["Title", "ISRC", "Artist", "Track Name", "Barcode", "Formats/Source Codes", "Genre", "Sub-genre"],
            fieldCode: ["releaseTitle", "iSrC", "releaseArtist", "trackName", "barcode", "releaseFormat", "genre", "subGenre"]
        },

    ]

    public static validationListing = [
        {
            fieldFor: "Contacts",
            fieldName: ["Contact Code", "Contact Name", "Contact Display", "Company Name", "First Name", "Last Name", "Email", "Website URL", "Address Line1", "Address Line2", "Address Line3", "Address Line4", "Address PostCode", "Telephone"],
            fieldCode: ["kontactCode", "kontactName", "kontactDisplay", "companyName", "firstName", "lastName", "email", "websiteURL", "addressLine1", "addressLine2", "addressLine3", "addressLine4", "addressPostCode", "telephone"]
        },
        {
            fieldFor: "Contracts",
            fieldName: ["Contract Ref", "Title", "Desc", "Contracted Party", "Label", "Type", "Reported"],
            fieldCode: ["contractRefNum", "contractTitle", "contractDesc", "contractedParty", "labelCode", "type", "reported"]
        },
        {
            fieldFor: "Contract Links",
            fieldName: ["Contract ref", "Contract Title", "Track Artist", "Code", "Track Name"],
            fieldCode: ["contractRefNum", "contractTitle", "trackArtist", "trackContactCode", "trackName"]
        },

        {
            fieldFor: "Upload Mechanicals", for: "mechanicalContract",
            fieldName: ["Contract Ref", "Artist", "Title", "Formats/Source Codes", "Zone", "Rate"],
            fieldCode: ["contractRefNum", "contractArtist", "contractTitle", "mechFormat", "zoneCode", "mechRate"]
        },
        {
            fieldFor: "Upload Mechanicals", for: "mechanicalTrackSplits",
            fieldName: ["ISRC", "Artist", "Collector Name", "Formats/Source Codes", "Writer Name", "Publisher Name", "Controlled", "Zone"],
            fieldCode: ["iSRC", "trackArtist", "collectorName", "formatCode", "writerName", "publisherName", "controlledYN", "zoneCode"]
        },
        {
            fieldFor: "Upload Mechanicals", for: "mechanicalLicenses",
            fieldName: ["Artist", "Collector Name", "Publisher Name", "Writer Name", "Title", "ISRC", "Release Code", "Zone", "Formats/Source Codes", "Controlled"],
            fieldCode: ["artistName", "collectorName", "publisherName", "writerName", "trackTitle", "iSRC", "releaseCode", "zoneCode", "formatCode", "controlledYN"]
        },

        {
            fieldFor: "Mappings", for: "mappingFormat",
            fieldName: ["Account Code", "Content", "Formats/Source Codes", "Provider", "Map To Code"],
            fieldCode: ["account", "subContent", "subFormat", "subProvider", "maptoCode"]
        },
        {
            fieldFor: "Mappings", for: "mappingCatalogue",
            fieldName: ["Account Code", "Artist", "Title", "Type", "Formats/Source Codes", "Album Code 1", "Album Code 2", "Track Code 1", "Track Code 2", "Item Code", "Rep Item Code"],
            fieldCode: ["accountCode", "albumArtist", "albumTitle", "headerType", "subFormat", "repAlbumCode1", "repAlbumCode2", "repTrackCode1", "repTrackCode2", "itemCodeSold", "repItemCodeSold"]
        },
        {
            fieldFor: "Mappings", for: "mappingRaw",
            fieldName: ["Account Code", "Invoice Ref", "Artist", "Title", "Item Code Sold", "Formats/Source Codes", "Provider", "Content", "Monetary Value"],
            fieldCode: ["accountCode", "invoiceRef", "albumArtist", "albumTitle", "itemCodeSold", "subFormat", "subProvider", "subContent", "monetaryValue"]
        },
        {
            fieldFor: "Mappings", for: "mappingAudit",
            fieldName: ["Account Code", "Invoice Ref", "Artist", "Title", "Item Code Sold", "Formats/Source Codes", "Provider", "Content", "Monetary Value"],
            fieldCode: ["accountCode", "invoiceRef", "albumArtist", "albumTitle", "itemCodeSold", "subFormat", "subProvider", "subContent", "monetaryValue"]
        },
        {
            fieldFor: "Mappings", for: "mappingAuditPub",
            fieldName: ["Account Code", "Invoice Ref", "Writer", "Item Code Sold", "Header Type", "Territory", "Royalty Period", "Monetary Value"],
            fieldCode: ["accountcode", "invoiceref", "writerName", "itemCodeSold", "headerType", "repTerritoryCode", "royaltyPeriod", "monetaryValue"]
        },

        {
            fieldFor: "Mappings", for: "mappingRawPub",
            fieldName: ["Account Code", "Invoice Ref", "Writer", "Publisher", "Title", "Rep Item Code Sold", "Header Type", "Royalty Period", "Code 1", "Code 2", "Code 3", "Code 4", "HFA", "ISWC", "Monetary Value"],
            fieldCode: ["accountcode", "invoiceref", "writerName", "publisherName", "albumTitle", "repItemCodeSold", "headerType", "royaltyPeriod", "songCode1", "songCode2", "songCode3", "songCode4", "hFACode", "iSWC", "monetaryValue"]
        },
        {
            fieldFor: "Mappings", for: "mappingAnalysisCode",
            fieldName: ["Code	Group", "Description	Costs", "Flat Fee", "Mechanicals", "Points", "Profits", "Analysis", "Analysis 2"],
            fieldCode: ["code", "group", "description", "costs", "flatFee", "mechanicals", "points", "profits", "analysisDIM1", "analysisDIM2"]
        },

        {
            fieldFor: "Mappings", for: "mappingClassList.excel",
            fieldName: ["Class List", "Release Alt 1", "Release Alt 2", "Release Alt 3", "Release Alt 4", "Release Alt 5", "Release Alt 6", "ISRC"],
            fieldCode: ["classList", "releaseAlt1", "releaseAlt2", "releaseAlt3", "releaseAlt4", "releaseAlt5", "releaseAlt6", "releaseIsRc"]
        },
        {
            fieldFor: "Mappings", for: "mappingClassList.mpm",
            fieldName: ["Class List", "Release Alt 1", "Release Alt 2", "Release Alt 3", "Release Alt 4", "Release Alt 5", "Release Alt 6", "ISRC"],
            fieldCode: ["classList", "releaseAlt1", "releaseAlt2", "releaseAlt3", "releaseAlt4", "releaseAlt5", "releaseAlt6", "releaseIsRc"]
        },

        {
            fieldFor: "Data Transfer", for: "artistContracts",
            fieldName: ["Artist", "Title", "Payor", "Payee", "Client Acc No"],
            fieldCode: ["f2", "f1", "f4", "f5", "f7"]
        },
        {
            fieldFor: "Data Transfer", for: "artistPayees",
            fieldName: ["Payee", "Client Acc No"],
            fieldCode: ["f1", "f2"]
        },
        {
            fieldFor: "Data Transfer", for: "transactionsLicense",
            fieldName: ["Artist", "Title", "Version", "Catalog No", "Label"],
            fieldCode: ["f4", "f1", "f2", "f3", "f5"]
        },
        {
            fieldFor: "Data Transfer", for: "transactionsPublisher",
            fieldName: ["Publisher", "Client Acc No"],
            fieldCode: ["f1", "f2"]
        },


        {
            fieldFor: "Minimum Set Uploader", for: "Releases",
            fieldName: ["Upc", "Title", "Artist", "Label", "Master Release", "Release Format", "Dim1", "ProductStatus", "ProductStatus Ext"],
            fieldCode: ["upc", "title", "artist", "label", "masterRelease", "releaseFormat", "dim1", "productStatus", "productStatusExt"]
        },

        {
            fieldFor: "Minimum Set Uploader", for: "Tracks",
            fieldName: ["Upc", "Title", "Artist", "Label", "Master Release", "Release Format", "Dim1", "ProductStatus", "ProductStatus Ext"],
            fieldCode: ["upc", "title", "artist", "label", "masterRelease", "releaseFormat", "dim1", "productStatus", "productStatusExt"]
        },

        {
            fieldFor: "Minimum Set Uploader", for: "Dealerprice",
            fieldName: ["Release Code", "CurrencyCode", "CurrencyDealer", "LocalDealer", "ExchRate", "PriceBasis", "TerritoryCode", "LicenseID", "Release Artist", "Release Title", "Dim1", "ProductStatus"],
            fieldCode: ["releaseCode", "currencyCode", "currencyDealer", "localDealer", "exchRate", "priceBasis", "territoryCode", "licenseID", "releaseArtist", "releaseTitle", "dim1", "productstatus"]
        },

        {
            fieldFor: "Minimum Set Uploader", for: "releaseTrack",
            fieldName: ["Upc", "Release Code", "Release Title", "Release Artist", "Master Release", "Label", "Master Release", "Release Format", "Tracks Title", "Tracks Artist", "ISRC", "volume", "Dim1", "ProductStatus", "ProductStatus Ext"],
            fieldCode: ["upc", "releaseCode", "releaseTitle", "releaseArtist", "masterRelease", "label", "masterRelease", "releaseFormat", "trackTitle", "trackArtist", "iSRC", "volume", "dim1", "productStatus", "productStatusExt"]
        },

        {
            fieldFor: "Minimum Set Uploader", for: "Songs",
            fieldName: ["Song Code", "Writer", "Publisher", "Share", "Song Title", "Imprint", "Dim1", "ProductStatus", "ProductStatus Ext"],
            fieldCode: ["songCode", "writer", "publisher", "share", "title", "imprint", "dim1", "productStatus", "productStatusExt"]
        },

        //CUE Upload
        {
            fieldFor: "CUE", for: "",
            fieldName: ["Cue Type", "Program Name", "Title", "ISWC", "Artist", "Cue Comment", "First Name", "Last Name", "Company", "Affiliation"],
            fieldCode: ["cueSheetType", "programName", "name", "iSWC", "artist", "cueComments", "firstName", "lastName", "companyName", "affiliation"]
        },

        {
            fieldFor: "Release/Track", for: "Track",
            fieldName: ["Artist", "ISRC", "Label", "Version", "Title", "Track Seq", "Duration", "Date"],
            fieldCode: ["Display_Artist", "IntStdRecCode", "Label", "TitleVersion", "TrackName", "TrackSeq", "TrackDuration", "TrackFirstAvailableDate"]
        },
        {
            fieldFor: "Release/Track", for: "Releases",
            fieldName: ["Artist", "Barcode", "CatLogNumber", "Master Release", "Formats/Source Codes", "Title", "Label"],
            fieldCode: ["Artist", "BarcodeNum", "CatLogNumber", "MasterRelease", "Format", "Title", "Label"]
        },

        {
            fieldFor: "Release/Track", for: "releaseTrack",
            fieldName: ["Title", "ISRC", "Artist", "Track Name", "Barcode", "Formats/Source Codes", "Genre", "Sub-genre"],
            fieldCode: ["releaseTitle", "iSrC", "releaseArtist", "trackName", "barcode", "releaseFormat", "genre", "subGenre"]
        },

    ]

    public static logName = [
        { name: 'Contacts', code: 'CN' },
        { name: 'Contracts', code: 'CU' },
        { name: 'Contract Links', code: 'CL' },
        { name: 'Upload Mechanicals', code: 'MU' },
        { name: 'Mappings', code: 'MM' },
        { name: 'Data Transfer', code: 'DT' },
        { name: 'Data Transfer', code: 'Deal' },
        { name: 'CUE', code: 'CUE' }
    ];


    /*************Search***************************** */
    static loadIFileLog(type: any, fileName: any, pageNumber: any, pageSize: any, source: any) {
        var url = 'importLog/SearchFileLog/' + type + '/' + fileName + '?pageNumber=' + pageNumber + '&pageSize=' + pageSize + '&source=' + source;
        return CommonUtilities.getData(url);
    };

    static loadIFileLogDetail(source: any) {
        var url = 'importLog/searchProgressImportLog/' + source;
        return CommonUtilities.getData(url);
    };

    static dataLoadContactSearch(param: any) {
        var url = 'dataLoadContact/searchDataloaderContacts?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static dataLoadContractSearch(param: any) {
        var url = 'dataLoadContract/searchDataloaderContracts?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static dataLoadContractLinksSearch(param: any) {
        var url = 'contractLinks/searchContractLinks?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static dataLoadContractLinksViewAll(param: any) {
        var url = 'contractLinks/detail?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static dataLoadmechanicalContractSearch(param: any) {
        var url = 'mechanicalUpload/searchMechanicalContract?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static dataLoadMechanicalTrackSplitsSearch(param: any) {
        var url = 'mechanicalUpload/searchMechanicalTrackSplits?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static dataLoadMechanicalLicenseSearch(param: any) {
        var url = 'mechanicalUpload/searchMechanicalLicense?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static dataLoadMappingfactsalesRawSearch(param: any) {
        var url = 'salesAnalysis/factsalesRaw/Search?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static dataLoadMappingfactsalesRawPubSearch(param: any) {
        var url = 'salesAnalysis/factsalesRawPub/Search?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    static songUploadList(param: any) {
        var url = 'MusicDirectory/assetUploader/song/list?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    static dealerPriceListing(param: any) {
        var url = 'MusicDirectory/assetUploader/CompPrices/dealerPrice/list?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static assetUploaderList(param: any) {
        var url = 'MusicDirectory/assetUploader/list?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static releaseTracklisting(param: any) {
        var url = 'MusicDirectory/assetUploader/releaseTracklisting?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    /**************View all ************* */
    static dataLoadContactViewAll(param: any) {
        var url = 'dataLoadContact/detail?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static dataLoadSongViewAll(param: any) {
        var url = 'songLoader/selectList?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static dataLoadContractViewAll(param: any) {
        var url = 'dataLoadContract/detail?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static dataLoadMechanicalContractViewAll(param: any) {
        var url = 'mechanicalUpload/detail/mechanicalContract?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static dataLoadMechanicalTrackSplitsViewAll(param: any) {
        var url = 'mechanicalUpload/detail/mechanicalTrackSplits?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static dataLoadMechanicalLicenseViewAll(param: any) {
        var url = 'mechanicalUpload/detail/mechanicalLicense?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static dataLoadMappingRawViewAll(param: any) {
        var url = 'dataLoadMapping/mappingmatch?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static dataLoadMappingRawPubViewAll(param: any) {
        var url = 'dataLoadMapping/mappingmatchPub?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static dataLoadmappingformatViewAll(param: any) {
        var url = 'dataLoadMapping/mappingformat?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static dataLoadmappingCatalogueViewAll(param: any) {
        var url = 'dataLoadMapping/mappingcatalogue?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static dataLoadmappinganalysiscodeViewAll(param: any) {
        var url = 'dataLoadMapping/mappinganalysiscode?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static dataLoadmappingclasslistViewAll(param: any) {
        var url = 'dataLoadMapping/mappingclasslist?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    /*  assetUploader_release  */
    static releaseTrackUploadViewAll(param: any) {
        var url = 'MusicDirectory/assetUploader/releaseTrack/list?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    //release
    static assetUploaderReleaseViewAll(param: any) {
        var url = 'MusicDirectory/assetUploader/release/list?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    //dealerPrice
    static dealerPriceViewAll(param: any) {
        var url = 'MusicDirectory/assetUploader/dealerPrice/list?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    /* Song */
    static songUploadViewAll(param: any) {
        var url = 'MusicDirectory/assetUploader/song/list?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    //track
    static assetUploaderTrackViewAll(param: any) {
        var url = 'MusicDirectory/assetUploader/track/list?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static cueViewAll(param: any) {
        var url = 'cue/selectList?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static metaReleaseTrackViewAll(pageNumber: any, pageSize: any) {
        var url = 'metaData/genericV1/detail/' + pageNumber + "/" + pageSize;
        return CommonUtilities.getData(url);
    }

    static metaReleaseViewAll(pageNumber: any, pageSize: any) {
        var url = 'metaData/genericV1/detail/release/' + pageNumber + "/" + pageSize;
        return CommonUtilities.getData(url);
    }

    static metaTrackViewAll(pageNumber: any, pageSize: any) {
        var url = 'metaData/genericV1/detail/track/' + pageNumber + "/" + pageSize;
        return CommonUtilities.getData(url);
    }

    static fugaStatus() {
        var url = 'metaData/fuga/status';
        return CommonUtilities.getData(url);
    }


    ////
    static getClientDetails() {
        var url = 'client/getClientDetails'
        return CommonUtilities.getData(url);
    }

    static bulkUpdateSummary(param: any) {
        var url = 'Contract/bulkUpdateSummary/listAll' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }


    /* ************************    export from table ******************************************** */
    static dataLoadContactExport(param: any) {
        var url = 'royalty/contactList?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.exportWithToken('GET', url, {}, param?.exportType, param?.filName);
    }

    static dataLoadContractExport(param: any) {
        var url = 'dataLoadContract/searchDataloaderContracts/export?' + CommonUtilities.buildQueryString(param, true, true);

        return CommonUtilities.exportVsWindowRespond(url);
        //return CommonUtilities.exportWithToken('GET', url, {}, param?.exportType, param?.type);
    }

    static dataLoadContractLinksExport(param: any) {
        var url = 'Api/contractLinks/searchContractLinks/export?' + CommonUtilities.buildQueryString(param, true, true);
        console.log(url)
        window.open(url);
        //return CommonUtilities.exportVsWindowRespond(url);
    }

    static dataLoadMechanicalUploadExport(param: any) {
        var url = 'mechanicalUpload/searchMechanicalContract/export?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.exportVsWindowRespond(url);
    }

    static InvalidErrorExport(data: any, filename: any) {
        var url = 'uploader/errorListing/Export'
        return CommonUtilities.postExport(url, data, filename);
    }

    static assetExport(param: any) {
        var url = 'MusicDirectory/assetUploader/assetExport?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.exportWithToken('GET', url, {}, '_blank', 'AssetDetails');
    }

    static CompPricesExport(param: any) {
        var url = 'MusicDirectory/assetUploader/CompPrices/dealerPrice/Export?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.exportWithToken('GET', url, {}, '_blank', 'CompPricesDetails');
    }

    static releaseTrackExport(param: any) {
        var url = 'MusicDirectory/assetUploader/releaseTracklisting/Export?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.exportWithToken('GET', url, {}, '_blank', 'ReleaseTrackDetails');
    }

    /* ************************     getById     ******************************************** */
    //contact
    static DataloaderContactGetById(param: any) {
        var url = 'uploader/contact/getById/' + param
        return CommonUtilities.getData(url);
    }

    //contact
    static DataloadercontractGetById(param: any) {
        var url = 'uploader/contract/getById/' + param
        return CommonUtilities.getData(url);
    }

    //contractLink
    static DataloadercontractLinkGetById(param: any) {
        var url = 'uploader/contractLink/getById/' + param
        return CommonUtilities.getData(url);
    }

    //cueUpload
    static DataloaderCueGetById(param: any) {
        var url = 'uploader/cueUpload/getById/' + param
        return CommonUtilities.getData(url);
    }

    //SongMetaDataUpload
    static DataloaderSongMetaDataGetById(param: any) {
        var url = 'uploader/SongMetaDataUpload/getById/' + param
        return CommonUtilities.getData(url);
    }

    static DataloaderDealerPriceGetById(param: any) {
        var url = 'MusicDirectory/assetUploader/dealerPrice/' + param
        return CommonUtilities.getData(url);
    }

    static releaseTrackUploaderById(param: any) {
        var url = 'MusicDirectory/assetUploader/releaseTrack/' + param
        return CommonUtilities.getData(url);
    }

    static SongUploaderById(param: any) {
        var url = 'MusicDirectory/assetUploader/song/' + param
        return CommonUtilities.getData(url);
    }

    static TrackUploaderById(param: any) {
        var url = 'MusicDirectory/assetUploader/track/' + param
        return CommonUtilities.getData(url);
    }

    static ReleaseUploaderById(param: any) {
        var url = 'MusicDirectory/assetUploader/release/' + param
        return CommonUtilities.getData(url);
    }


    static metadataReleaseTrackUploaderById(param: any) {
        var url = 'uploader/metaDataGeneric/getById/' + param
        return CommonUtilities.getData(url);
    }
    static DataloaderMetaDataGenericTrackGetById(param: any) {
        var url = 'uploader/metaDataGenericTracks/getById/' + param
        return CommonUtilities.getData(url);
    }

    static DataloaderMetaDataGenericCompilationsGetById(param: any) {
        var url = 'uploader/metaDataGenericCompilations/getById/' + param
        return CommonUtilities.getData(url);
    }

    //

    /* ************************    file uploading******************************************** */
    //contact
    static dataLoadContactFileUpload(file: any) {
        var url = 'dataLoadContact/fileUpload'
        return CommonUtilities.postUploadFile(url, file, {});
    }
    //contract
    static dataLoadContractFileUpload(file: any) {
        var url = 'dataLoadContract/fileUpload'
        return CommonUtilities.postUploadFile(url, file, {});
    }
    //contractLink
    static dataLoadcontractLinksFileUpload(file: any) {
        var url = 'contractLinks/fileUpload'
        return CommonUtilities.postUploadFile(url, file, {});
    }
    //Mechanical Upload
    static dataLoadMechanicalFileUpload(file: any) {
        var url = 'mechanicalUpload/fileUpload'
        return CommonUtilities.postUploadFile(url, file, {});
    }
    //Mapping
    static dataLoadMappingFileUpload(file: any) {
        var url = 'dataLoadMapping/fileUpload'
        return CommonUtilities.postUploadFile(url, file, {});
    }
    //data Transfer
    static dataTransferFileUpload(file: any) {
        var url = 'dataTransfer/fileUpload'
        return CommonUtilities.postUploadFile(url, file, {});
    }

    static minimumSetTrackUpload(file: any) {
        console.log(file)
        var url = 'MusicDirectory/musicAssetDirectory/trackUpload';
        return CommonUtilities.postUploadFile(url, file, null);
    }

    static minimumSetReleaseUpload(file: any) {
        console.log(file)
        var url = 'MusicDirectory/musicAssetDirectory/releaseUpload';
        return CommonUtilities.postUploadFile(url, file, null);
    }

    static minimumSetDealerPriceUpload(file: any) {
        console.log(file)
        var url = 'MusicDirectory/musicAssetDirectory/dealerPriceUpload';
        return CommonUtilities.postUploadFile(url, file, null);
    }

    static minimumSetTrackReleaseUpload(file: any) {
        console.log(file)
        var url = 'MusicDirectory/musicAssetDirectory/trackReleaseUpload';
        return CommonUtilities.postUploadFile(url, file, null);
    }

    static minimumSetSongUpload(file: any) {
        console.log(file)
        var url = 'songLoader/fileUploadMinSet';
        return CommonUtilities.postUploadFile(url, file, null);
    }

    static genericV1fileUpload(file: any, param: any) {
        var url = 'metaData/genericV1/fileUpload';
        return CommonUtilities.postUploadFile(url, file, param);
    }

    static cwrUpload(file: any) {
        var url = 'publishing/dataload/cwrUpload';
        return CommonUtilities.postUploadFile(url, file, {});
    }

    static cuefileUpload(file: any) {
        var url = 'cue/fileUpload';
        return CommonUtilities.postUploadFile(url, file, {});
    }

    static songUpload(file: any) {
        var url = 'songLoader/fileUpload';
        return CommonUtilities.postUploadFile(url, file, {});
    }

    static BundleUpload(file: any) {
        var url = 'MusicDirectory/assetBundles/fileUpload';
        return CommonUtilities.postUploadFile(url, file, {});
    }
    /* ************************    file upload count ******************************************** */
    //contract
    static dataLoadContractCount() {
        var url = 'dataLoadContract/count'
        return CommonUtilities.getData(url);
    }
    //contractLink
    static dataLoadcontractLinksCount() {
        var url = 'contractLinks/count'
        return CommonUtilities.getData(url);
    }
    //contact
    static dataLoadContactCount() {
        var url = 'dataLoadContact/count'
        return CommonUtilities.getData(url);
    }
    //Mechanical Upload
    static dataLoadMechanicalUploadCount(param: any) {
        var url = 'mechanicalUpload/count?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    //Mapping
    static dataLoadMappingCount(param: any) {
        var url = 'dataLoadMapping/mapping/count?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    //dataTransfer
    static dataTransferCount() {
        var url = 'dataTransfer/count';
        return CommonUtilities.getData(url);
    }
    //Minimum set Uploader

    static minimumSetMetaData(param: any) {
        var url = 'MusicDirectory/assetUploader/count?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static genericV1Count() {
        var url = 'metaData/genericV1/count';
        return CommonUtilities.getData(url);
    }
    static genericV1TypeCount(param: any) {
        var url = 'metaData/genericV1/typeCount?' + CommonUtilities.buildQueryString(param, true, true);;
        return CommonUtilities.getData(url);
    }
    static CueCount() {
        var url = 'cue/count';
        return CommonUtilities.getData(url);
    }
    static songLoaderCount() {
        var url = 'songLoader/count';
        return CommonUtilities.getData(url);
    }

    static suggestedPaymentsCount() {
        var url = 'contracts/suggestedPayments/count'
        return CommonUtilities.getData(url);
    }
    /* ************************    filevalidation ******************************************** */
    ///contact
    static dataLoadContactValidation(param: any) {
        var url = 'dataLoadContact/validation?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    ///contract
    static dataLoadContractValidation(param: any) {
        var url = 'dataLoadContract/validation?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    ///contractLink
    static dataLoadContractLinksValidation() {
        var url = 'contractLinks/validation';
        return CommonUtilities.getData(url);
    }
    ///songLoader
    static dataLoadSongValidation() {
        var url = 'songLoader/validation';
        return CommonUtilities.getData(url);
    }
    ///mechanicalUpload
    static dataLoadmechanicalUploadValidation(param: any) {
        var url = 'mechanicalUpload/validation?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    ///dataLoadMapping
    static dataLoadMappingValidation(param: any) {
        var url = 'dataLoadMapping/validation?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    //dataTransfer
    static dataLoaddataTransferValidation(param: any) {
        var url = 'dataTransfer/validation?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static metadatavalidation(param: any) {
        var url = 'MusicDirectory/assetBundles/validation?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static CWRvalidation(param: any) {
        var url = 'publishing/song/CWRvalidation?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static CUEvalidation() {
        var url = 'cue/validation'
        return CommonUtilities.getData(url);
    }

    static MetaDatatrackReleasevalidation() {
        var url = 'metaData/genericV1/validate/trackAndRelease'
        return CommonUtilities.getData(url);
    }

    static genericV1validation(param: any) {
        var url = 'metaData/genericV1/typeValidate?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static suggestedPaymentsvalidation() {
        var url = 'contracts/suggestedPayments/validation'
        return CommonUtilities.getData(url);
    }


    /* ************************    Edit save ******************************************** */

    static DataloaderContactSave(data: any) {
        var url = 'uploader/contact/save'
        return CommonUtilities.postData(url, data);
    }

    static DataloadercontractSave(data: any) {
        var url = 'uploader/contract/save'
        return CommonUtilities.postData(url, data);
    }

    static DataloadercontractLinkSave(data: any) {
        var url = 'uploader/contractLink/save'
        return CommonUtilities.postData(url, data);
    }

    static DataloaderMetaDataGenericTrackSave(data: any) {
        var url = 'uploader/metaDataGenericTracks/save'
        return CommonUtilities.postData(url, data);
    }

    static DataloaderMetaDataGenericCompilationsSave(data: any) {
        var url = 'uploader/metaDataGenericCompilations/save'
        return CommonUtilities.postData(url, data);
    }

    static DataloaderMetaDataGenericSave(data: any) {
        var url = 'uploader/metaDataGeneric/save'
        return CommonUtilities.postData(url, data);
    }

    static DataloaderCueSave(data: any) {
        var url = 'uploader/cueUpload/save'
        return CommonUtilities.postData(url, data);
    }

    static DataloaderSongMetaDataSave(data: any) {
        var url = 'uploader/SongMetaDataUpload/save'
        return CommonUtilities.postData(url, data);
    }


    static DataloaderMinSetReleaseSave(param: any) {
        var url = 'MusicDirectory/assetUploader/release/save'
        return CommonUtilities.postData(url, param);
    }

    static DataloaderMinSetTrackSave(param: any) {
        var url = 'MusicDirectory/assetUploader/track/save'
        return CommonUtilities.postData(url, param);
    }

    static DataloaderMinSetReleaseTrackSave(param: any) {
        var url = 'MusicDirectory/assetUploader/releaseTrack/save'
        return CommonUtilities.postData(url, param);
    }

    static DataloaderMinSetDealerPriceSave(param: any) {
        var url = 'MusicDirectory/assetUploader/dealerPrice/save'
        return CommonUtilities.postData(url, param);
    }

    static DataloaderMinSetSongSave(param: any) {
        var url = 'MusicDirectory/assetUploader/song/save'
        return CommonUtilities.postData(url, param);
    }

    /* ************************   DELETE UPLOAD DATA ******************************************** */
    static DataloaderContactDelete(data: any) {
        var url = 'uploader/contact/delete/' + data
        return CommonUtilities.deleteData(url);
    }

    static DataloadercontractLinkDelete(data: any) {
        var url = 'uploader/contractLink/delete/' + data
        return CommonUtilities.deleteData(url);
    }

    static DataloadercontractDelete(data: any) {
        var url = 'uploader/contract/delete/' + data
        return CommonUtilities.deleteData(url);
    }

    static DataloadermetaDataGenericDelete(data: any) {
        var url = 'uploader/metaDataGeneric/delete/' + data
        return CommonUtilities.deleteData(url);
    }

    static DataloaderMetaDataGenericTrackDelete(data: any) {
        var url = 'uploader/metaDataGenericTracks/delete/' + data
        return CommonUtilities.deleteData(url);
    }

    static DataloaderMetaDataGenericCompilationsDelete(data: any) {
        var url = 'uploader/metaDataGenericCompilations/delete/' + data
        return CommonUtilities.deleteData(url);
    }

    static DataloaderCueDelete(data: any) {
        var url = 'uploader/cueUpload/delete/' + data
        return CommonUtilities.deleteData(url);
    }

    static DataloaderSongMetaDataDelete(data: any) {
        var url = 'uploader/SongMetaDataUpload/delete/' + data
        return CommonUtilities.deleteData(url);
    }


    static DataloaderMinUploaderDealerPriceDelete(param: any) {
        var url = 'MusicDirectory/assetUploader/dealerPrice/delete/' + param
        return CommonUtilities.deleteData(url);
    }

    static DataloaderMinUploaderReleaseTrackDelete(param: any) {
        var url = 'MusicDirectory/assetUploader/releaseTrack/delete/' + param
        return CommonUtilities.deleteData(url);
    }

    static DataloaderMinUploaderTrackDelete(param: any) {
        var url = 'MusicDirectory/assetUploader/track/delete/' + param
        return CommonUtilities.deleteData(url);
    }

    static DataloaderMinUploaderReleaseDelete(param: any) {
        var url = 'MusicDirectory/assetUploader/release/delete/' + param
        return CommonUtilities.deleteData(url);
    }

    static DataloaderMinUploaderSongDelete(param: any) {
        var url = 'MusicDirectory/assetUploader/song/delete/' + param
        return CommonUtilities.deleteData(url);
    }



    /* ************************    file commit ******************************************** */
    //contact
    static dataLoadContactCommit(param: any) {
        var url = 'dataLoadContact/commit?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    //contract
    static dataLoadContractCommit(param: any) {
        var url = 'dataLoadContract/commit?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    //contractLink
    static dataLoadContractLinksCommit() {
        var url = 'contractLinks/commit'
        return CommonUtilities.getData(url);
    }
    //mechanicalUpload
    static dataLoadMechanicalCommit(param: any) {
        var url = 'mechanicalUpload/commit?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    //dataLoadMapping
    static dataLoadMappingCommit(param: any) {
        var url = 'dataLoadMapping/mapping/commit?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    //dataTransfer
    static dataTransferCommit(param: any) {
        var url = 'dataTransfer/commit?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    //Release/Track
    static UpdateNextIRSCommit(param: any) {
        var url = 'metadata/track/updateNextIRSCForLabels?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    //Release/Track
    static DealerPriceCommit(param: any) {
        var url = 'dataLoadContact/commit?type=DealerPrice&useReleaseCodeAsMaster=0'
        return CommonUtilities.getData(url);
    }

    static saveISRCPrefix(param: any) {
        var url = 'metadata/track/saveISRCPrefix?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static genericV1MetadataCommit(param: any) {
        var url = 'metaData/genericV1/commit?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }


    static rejectCWRFile(param: any) {
        var url = 'publishing/dataload/rejectCWRFile?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }


    static processThisCWRFile(param: any) {
        var url = 'publishing/dataload/processThisCWRFile?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }


    static cuecommit() {
        var url = 'cue/commit'
        return CommonUtilities.getData(url);
    }

    /* ************************    validation List ******************************************** */

    static contactValidationList(param: any) {
        var url = 'uploader/contact/validationList?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static contractValidationList(param: any) {
        var url = 'uploader/contract/validationList?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static contractLinkValidationList(param: any) {
        var url = 'uploader/contractLink/validationList?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static metadataValidationList(param: any) {
        var url = 'uploader/metaDataGeneric/validationList?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static CueValidationList(param: any) {
        var url = 'uploader/cueUpload/validationList?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static SongMetaDataValidationList(param: any) {
        var url = 'uploader/SongMetaDataUpload/validationList?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }



    static DealerPricevalidationList(param: any) {
        var url = 'MusicDirectory/assetUploader/dealerPrice/validationList?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    static ReleaseTrackvalidationList(param: any) {
        var url = 'MusicDirectory/assetUploader/releaseTrack/validationList?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static TrackvalidationList(param: any) {
        var url = 'MusicDirectory/assetUploader/track/validationList?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static ReleasevalidationList(param: any) {
        var url = 'MusicDirectory/assetUploader/release/validationList?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }


    /* ************************    file upload clear ******************************************** */
    //contact
    static dataLoadContactClear() {
        var url = 'dataLoadContact/clear';
        return CommonUtilities.getData(url);
    }
    //contract
    static dataLoadContractClear() {
        var url = 'dataLoadContract/clear';
        return CommonUtilities.getData(url);
    }
    //contractLink
    static dataLoadContractLinksClear() {
        var url = 'contractLinks/clear';
        return CommonUtilities.getData(url);
    }
    //mechanicalUpload
    static dataLoadMechanicalClear(param: any) {
        var url = 'mechanicalUpload/clear?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    //dataLoadMapping
    static dataLoadMappingClear(param: any) {
        var url = 'dataLoadMapping/mapping/clear?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    //dataLoadTransfer
    static dataLoadTransferClear(param: any) {
        var url = 'dataTransfer/clear?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    /* releaseTrack_track  */
    static clearUploadGenericV1() {
        var url = 'metaData/genericV1/clear';
        return CommonUtilities.getData(url);
    }

    static clearUploadGenericV1release() {
        var url = 'metaData/genericV1/typeClear?type=release';
        return CommonUtilities.getData(url);
    }

    static clearUploadGenericV1Track() {
        var url = 'metaData/genericV1/typeClear?type=track';
        return CommonUtilities.getData(url);
    }


    /* releaseTrack_track  */
    static clearUploadReleaseTrack() {
        var url = 'MusicDirectory/assetUploader/releaseTrack/clear';
        return CommonUtilities.getData(url);
    }

    static clearUploadDealerPrice() {
        var url = 'MusicDirectory/assetUploader/dealerPrice/clear';
        return CommonUtilities.getData(url);
    }

    static clearUploadSongs() {
        var url = 'songLoader/clearMinSet';
        return CommonUtilities.getData(url);
    }

    static songLoaderclear() {
        var url = 'songLoader/clear';
        return CommonUtilities.getData(url);
    }

    static clearUploadRelease() {
        var url = 'MusicDirectory/assetUploader/release/clear';
        return CommonUtilities.getData(url);
    }

    /* assetUploader_track  */
    static clearUploadTrack() {
        var url = 'MusicDirectory/assetUploader/track/clear';
        return CommonUtilities.getData(url);
    }

    /* cueClear  */
    static cueClear() {
        var url = 'cue/clear';
        return CommonUtilities.getData(url);
    }


    static genericAPIListing(param: any) {
        var url = 'common/genericListing';
        return CommonUtilities.postData(url, param)
    }
}